/** Direct PDF paths for guide/report assets shown on the marketing thank-you page. */
export const AI_INDUSTRY_2026_GUIDE_PDF_PATH =
    '/guides/ai-industry-2026/2026-ai-guide-for-founders.pdf';

export const AI_ENTERPRISE_PLAYBOOK_PDF_PATH =
    '/guides/ai-enterprise-playbook/ai-enterprise-playbook.pdf';

const ASSET_DOWNLOAD_PATHS: Record<string, string> = {
    'AI Industry 2026': AI_INDUSTRY_2026_GUIDE_PDF_PATH,
    'AI Enterprise Playbook': AI_ENTERPRISE_PLAYBOOK_PDF_PATH,
};

const REPORT_DOWNLOAD_PATHS: Record<string, string> = {
    'ai-industry-2026': AI_INDUSTRY_2026_GUIDE_PDF_PATH,
    'ai-enterprise-playbook': AI_ENTERPRISE_PLAYBOOK_PDF_PATH,
};

export function resolveMarketingAssetDownloadPath(params: {
    asset?: string | null;
    report?: string | null;
}): string | undefined
{
    const asset = params.asset?.trim();
    if (asset && ASSET_DOWNLOAD_PATHS[asset])
    {
        return ASSET_DOWNLOAD_PATHS[asset];
    }

    const report = params.report?.trim();
    if (report && REPORT_DOWNLOAD_PATHS[report])
    {
        return REPORT_DOWNLOAD_PATHS[report];
    }

    return undefined;
}

export function toPublicAssetPath(path: string): string
{
    return `${process.env.PUBLIC_URL || ''}${path}`;
}
